import React from 'react'
import PropTypes from 'prop-types'
import ImmutablePropTypes from 'react-immutable-proptypes'
import { Field, FieldArray } from 'redux-form/immutable'
// @ts-ignore
import { get } from 'lodash'
import i18next from 'i18next'

// @ts-ignore
import TextArea from 'app/components/TextArea'
// @ts-ignore
import Select from 'app/components/Select'
// @ts-ignore
import CheckBox from 'app/components/CheckBox'
import Button from 'app/components/ButtonDefault'
import SelectArray from './SelectArray'
import { BULK_MANAGEMENT_FORM_TYPE } from 'app/constants/bulkManagement'

import './styles.scss'
import cn from 'classnames'
import { IBulkManagementFormProps } from './interface'
import { getFormActionButtonLabel, getFormTitle } from 'helpers/bulkManagement'

const bc = 'manage-protracks-form'

const validateProTrackLevel = (value: string) =>
  value === '0' ? `${i18next.t('Please select')} ${i18next.t('ProTrackLevel')}` : undefined

const BulkManagementForm: React.FC<IBulkManagementFormProps> = ({
  handleSubmit,
  teams,
  pristine,
  proTrackLevels,
  isWaitingProTrackLevels,
  isEntireOrg,
  isTeamsEnter,
  isEmailsEnter,
  isSuperOrMultiAdmin,
  t,
  i18n: { language },
  formType,
  firstHistorySwitch,
}) => {
  console.log('firstHistorySwitch', firstHistorySwitch)
  const isPending = firstHistorySwitch && firstHistorySwitch.isPending
  return (
    <div className={`${bc}__wrapper`}>
      <span className={`${bc}__title`}>
        {isPending
          ? i18next.t('admin:Please wait while the system processes the request to switch users')
          : getFormTitle(formType)}
      </span>
      {!isPending && (
        <form onSubmit={handleSubmit}>
          <div className={`${bc}__form`}>
            <div className={`${bc}__left`}>
              <div className={`${bc}__wrapper-input-emails`}>
                <Field
                  name="emails"
                  component={TextArea}
                  placeholder={t('Email Address')}
                  needCharactersLabel={false}
                  style={{ width: '350px' }}
                  className={`${bc}__input-emails`}
                  disabled={isEntireOrg}
                  label={t('admin:List of individual emails')}
                />
                <span className={`${bc}__tip`}>
                  {t('common:Format')}: {t('admin:one email per line')}
                </span>
              </div>
              <div className={cn(`${bc}__and-or`, { [`${bc}__and-or__${language}`]: language })} />
              {/* @ts-ignore */}
              <FieldArray name="teams" component={SelectArray} options={teams} disabled={isEntireOrg} />
            </div>
            <div className={cn(`${bc}__or`, { [`${bc}__or__${language}`]: language })} />
            <div className={`${bc}__right`}>
              <div>
                <div className={`${bc}__label`}>{t('admin:Entire Company')}</div>
                <Field
                  name="entireOrg"
                  component={CheckBox}
                  label={t('admin:Entire Organization')}
                  disabled={isEmailsEnter || isTeamsEnter}
                />
              </div>
              {formType === BULK_MANAGEMENT_FORM_TYPE.SWITCH_PROTRACK &&
                (isWaitingProTrackLevels ? (
                  <div
                    className="loader__row"
                    style={{
                      height: 30,
                      width: 250,
                      display: 'inline-block',
                      marginRight: 25,
                    }}
                  />
                ) : (
                  <Field
                    name="proTrackLevelId"
                    component={Select}
                    options={proTrackLevels}
                    getValue={(option: any) => option.id || '0'}
                    getLabel={(option: any) =>
                      option.id ? `${get(option, 'proTrack.name')} – ${option.name}` : option
                    }
                    getKey={(option: any) => (option.id ? `${option.name}_${option.id}` : option)}
                    styleSelect={{ width: '300px' }}
                    validate={[validateProTrackLevel]}
                    label={t('admin:Next ProTrack')}
                    isRowView={false}
                    labelClassName={`${bc}__label`}
                  />
                ))}
            </div>
          </div>
          <div className={`${bc}__buttons`}>
            {formType === BULK_MANAGEMENT_FORM_TYPE.SWITCH_PROTRACK && isSuperOrMultiAdmin && (
              <Field
                name="switchStoppedUsers"
                component={CheckBox}
                label={t('admin:Include Stopped/Paused Users')}
                style={{ marginRight: 14 }}
              />
            )}
            <Button xs primary type="submit" disabled={pristine || (!isEmailsEnter && !isEntireOrg && !isTeamsEnter)}>
              {getFormActionButtonLabel(formType)}
            </Button>
          </div>
        </form>
      )}
    </div>
  )
}

export default BulkManagementForm
